<div class="coins-page">
  <div class="coins-page__breadcrumb">
    <div class="coins-page__inner">
      <app-breadcrumb [items]="breadcrumbs" />
    </div>
  </div>

  <!-- Hero -->
  <section class="coins-section coins-section--alt coins-hero">
    <div class="coins-page__inner coins-hero__layout">
      <div class="coins-hero__text">
        <p class="coins-hero__eyebrow">{{ copy.EYEBROW }}</p>
        <h1 class="coins-hero__title">{{ copy.TITLE }}</h1>
        <p class="coins-hero__intro">{{ copy.INTRO }}</p>
      </div>
      <img
        ngSrc="images/logo/info.png"
        width="481"
        height="640"
        alt=""
        priority
        class="coins-hero__mascot"
      />
    </div>
  </section>

  <!-- Cómo ganas Coins -->
  <section class="coins-section" aria-labelledby="coins-earn-title">
    <div class="coins-page__inner">
      <h2 id="coins-earn-title" class="coins-section__title">{{ copy.EARN_TITLE }}</h2>
      <ul class="coins-cards" role="list">
        @for (way of earnWays; track way.title) {
          <li class="coins-card">
            <span class="coins-card__icon" aria-hidden="true">
              <app-icon [icon]="way.icon" [size]="22" />
            </span>
            <h3 class="coins-card__title">{{ way.title }}</h3>
            <p class="coins-card__text">{{ way.text }}</p>
          </li>
        }
      </ul>
    </div>
  </section>

  <!-- Para qué sirven -->
  <section class="coins-section coins-section--alt" aria-labelledby="coins-use-title">
    <div class="coins-page__inner">
      <h2 id="coins-use-title" class="coins-section__title">{{ copy.USE_TITLE }}</h2>
      <ul class="coins-cards" role="list">
        <li class="coins-card coins-card--vip">
          <span class="coins-card__icon coins-card__icon--vip" aria-hidden="true">
            <app-icon [icon]="vipIcon" [size]="22" />
          </span>
          <h3 class="coins-card__title">{{ copy.USE_VIP_TITLE }}</h3>
          <p class="coins-card__text">{{ copy.USE_VIP_TEXT }}</p>
        </li>
      </ul>
    </div>
  </section>

  <!-- Valor futuro (oculto si no se conoce) y CTA final -->
  <section class="coins-section">
    <div class="coins-page__inner coins-closing">
      @if (valueLoading()) {
        <div class="coins-value coins-value--skeleton" aria-busy="true">
          <span class="coins-value__skeleton-line coins-value__skeleton-line--title"></span>
          <span class="coins-value__skeleton-line coins-value__skeleton-line--text"></span>
        </div>
      } @else if (valueText(); as text) {
        <div class="coins-value">
          <h2 class="coins-value__title">{{ copy.VALUE_TITLE }}</h2>
          <p class="coins-value__text">{{ text }}</p>
        </div>
      }

      <div class="coins-cta">
        @if (isAuthenticated()) {
          <a routerLink="/perfil/coins" class="coins-cta__link">{{ copy.CTA_SIGNED_IN }}</a>
        } @else {
          <app-button variant="primary" size="md" (click)="openLogin()">{{ copy.CTA_SIGNED_OUT }}</app-button>
        }
      </div>
    </div>
  </section>
</div>
